import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Assets
// import ClientLogo01 from "../../assets/img/clients/logo01.svg";
// import ClientLogo02 from "../../assets/img/clients/logo02.svg";
// import ClientLogo03 from "../../assets/img/clients/logo03.svg";
// import ClientLogo04 from "../../assets/img/clients/logo04.svg";
// import ClientLogo05 from "../../assets/img/clients/logo05.svg";
// import ClientLogo06 from "../../assets/img/clients/logo06.svg";
import JaquarLogo from "../../assets/jpg_png/JaquarLogo.svg";
import Parryware from "../../assets/jpg_png/parryware.png";
import Varmora from "../../assets/jpg_png/Logo-Varmora.jpg";
import Roca from "../../assets/jpg_png/roca.png";
import Cera from "../../assets/jpg_png/cera.jpg";
//Css
import "../../style/TopNavbar.css";
export default function ClientSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 2,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={JaquarLogo} alt="client logo" />
        </LogoWrapper>
        {/* <LogoWrapper className="flexCenter client-Services">
          <h3>Residential Villas & FarmHouses</h3>
        </LogoWrapper> */}
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Parryware} alt="client logo" />
        </LogoWrapper>
        {/* <LogoWrapper className="flexCenter client-Services">
          <h3>Commercial Showrooms</h3>
        </LogoWrapper> */}
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Varmora} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter client-Services">
          <h3>Apartments</h3>
        </LogoWrapper>
        <LogoWrapper className="flexCenter ">
          <ImgStyle src={Roca} alt="client logo"  style={{backgroundColor:"#111"}}/>
        </LogoWrapper>
        <LogoWrapper className="flexCenter ">
          <ImgStyle src={Cera} alt="client logo" />
        </LogoWrapper>

        {/* <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo03} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo04} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo01} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo02} alt="client logo" />
        </LogoWrapper> */}
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 100%;
  height: 100px;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
const ImgStyle = styled.img`
  width: 100%;
  height: 100%;
  padding: 10%;
`;
